import { composeWithDevTools } from 'redux-devtools-extension';
import { createStore } from 'redux';

import { searchReducer } from './reducers/searchReducer';

export const store = createStore(searchReducer, composeWithDevTools());
